import $ from "jquery";

class BeautyCategoryPage {
  constructor() {
    this.featureTabSelector = ".js-category-feature-tab-item";
    this.featureItemSelector = ".js-category-feature-item";

    this.$featureTabItem = $(this.featureTabSelector);
    this.$featureItem = $(this.featureItemSelector);
  }

  init() {
    this.handleFeatureTabClick();
    //this.initFaqToggle();
  }

  handleFeatureTabClick() {
    this.$featureTabItem.on("click", (e) => {
      const $target = $(e.currentTarget);
      const targetId = $target.data("tab-id");
      const selectedFeatureItem = this.$featureItem.filter(`#${targetId}`);

      this.$featureTabItem.removeClass("active");
      $target.addClass("active");

      this.$featureItem.removeClass("active fade-in");
      selectedFeatureItem.addClass("active");
      
      setTimeout(() => {
        selectedFeatureItem.addClass("fade-in");
      }, 50);
    });
  }

  // initFaqToggle() {
  //   $(".faq-section .masonry-grid--item-toggler").on("click", function () {
  //     $(this).toggleClass("--active");
  //     $(this).closest(".masonry-grid--item").find(".masonry-grid--item-body").slideToggle();
  //   });
  // }
}

const beautyCategoryPage = new BeautyCategoryPage();
beautyCategoryPage.init();
